'use client';

// TODO: Remove this component - check if not in use

import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import CustomLink from 'components/shared/CustomLink';
import { useState } from 'react';
import { CrossDark, CaretUp } from '../../assets/icons';
import styles from './ProductMenuButtonAndOverlay.module.css';

const ProductCard = ({
  image,
  title,
  subtitle,
  ctaTitle,
  ctaHref,
}: {
  image?: string;
  title?: string;
  subtitle?: string;
  ctaTitle?: string;
  ctaHref?: string;
}) => {
  const searchParams = useSearchParams();
  const query: Record<string, string | string[]> = {};
  if (searchParams) {
    for (const key of searchParams.keys()) {
      const values = searchParams.getAll(key);
      query[key] = values.length > 1 ? values : values[0];
    }
  }
  return (
    <div
      className={styles.productCard}
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(0,0, 0, .2), rgba(0,0, 0, .2)), url(${image})`,
      }}
    >
      <h2 className={styles.polTitle}>{title}</h2>
      <p className={styles.polSubtitle}>{subtitle}</p>
      <div
        className={styles.polBtns}
        onClick={(e) => e.stopPropagation()}
        aria-hidden="true"
      >
        <CustomLink
          href={{ pathname: ctaHref, query }}
          className={styles.polPrimary}
        >
          {ctaTitle}
        </CustomLink>
      </div>
    </div>
  );
};

const ProductMenuOverlay = ({
  stateFunction,
}: {
  stateFunction: (arg: boolean) => void;
}) => {
  const t = useTranslations('common');
  const closeOverlay = () => {
    stateFunction(false);
  };
  return (
    <div className={styles.overlay} onClick={closeOverlay} aria-hidden="true">
      <div
        className={styles.polContent}
        onClick={(e) => e.stopPropagation()}
        aria-hidden="true"
      >
        <div
          className={styles.polCloseBtn}
          onClick={closeOverlay}
          aria-hidden="true"
        >
          <CrossDark />
        </div>
        <div className={styles.polProductRow}>
          <ProductCard
            title={t('common.productMenu.m1Title')}
            subtitle={t('common.productMenu.m1Subtitle')}
            ctaTitle={t('common.productMenu.exploreM1')}
            ctaHref="/pricing"
            image="https://public-web-assets.ultrahuman.com/cdn-cgi/image/width=500,fit=scale-down/web/product-overlay-menu/m1-bg.png"
          />
          <ProductCard
            title={t('common.productMenu.ringTitle')}
            subtitle={t('common.productMenu.ringSubtitle')}
            ctaTitle={t('common.productMenu.exploreRing')}
            ctaHref="/ring"
            image="https://public-web-assets.ultrahuman.com/cdn-cgi/image/width=500,fit=scale-down/web/product-overlay-menu/ring-bg.png"
          />
        </div>
        <div className={styles.polSecondaryRow}>
          <CustomLink
            href="https://form.typeform.com/to/yOi1E7Wy?utm_source=web"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className={styles.secTitle}>
              {t('common.productMenu.getRightPlans')}
            </span>
            <span className={styles.secSubtitle}>
              {t('common.productMenu.talkToSpecialist')}{' '}
              <CaretUp style={{ transform: 'rotate(90deg)' }} />
            </span>
          </CustomLink>
        </div>
      </div>
    </div>
  );
};

export const ProductMenuButtonAndOverlay = ({
  className,
  btnType,
  btnTitle,
}: {
  className?: string;
  btnType: 'fill' | 'outline';
  btnTitle?: string;
}) => {
  const t = useTranslations('common');
  const [isOverlayVisible, setOverlayVisible] = useState(false);
  return (
    <>
      <button
        className={`${styles.menuButton} ${className ?? ''} ${btnType} product-overlay-button`}
        onClick={() => setOverlayVisible(true)}
      >
        {btnTitle ?? t('common.productMenu.exploreProducts')}
      </button>
      {isOverlayVisible && (
        <ProductMenuOverlay stateFunction={setOverlayVisible} />
      )}
    </>
  );
};

// use class "product-overlay-button" to target the btn
